import { add, parse } from 'date-fns'
import { IPolicy } from '../models/policy'

const showValueMeter = (policy: IPolicy): boolean => {
  const { productName, details } = policy

  const underinsuranceGuaranteDate = details.find(
    (detail) => detail.name === 'underinsurance_guarantee_date'
  )

  const blockMutationReason = policy.details?.find(
    (detail) => detail.name === 'block_mutation_reason'
  )

  if (
    !underinsuranceGuaranteDate ||
    typeof underinsuranceGuaranteDate.value !== 'string' ||
    policy.pendingMutations ||
    blockMutationReason?.value === true
  ) {
    return false
  }

  const isOlderThan57Months =
    new Date() >=
    add(parse(underinsuranceGuaranteDate.value, 'dd-MM-yyyy', new Date()), {
      months: 57
    })

  return (
    (productName === 'Inboedel' || productName === 'Woonhuis') &&
    isOlderThan57Months
  )
}

export default showValueMeter
